import React from 'react';
import {
  Box,
  Chip,
  IconButton,
  Tooltip,
  Badge,
  Typography,
  Grid,
} from '@mui/material';
import NotificationsIcon from '@mui/icons-material/Notifications';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import PropTypes from 'prop-types';

/**
 * ChipsBadgesShowcase Component
 * Displays chips and badges with theme styling
 */
const ChipsBadgesShowcase = ({ theme }) => {
  return (
    <Grid size={{ xs: 12, md: 6 }}>
      <Typography variant="subtitle2" gutterBottom>
        Chips & Badges
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
        <Chip
          label="Primary"
          sx={{
            backgroundColor: theme.primary_color,
            color: '#ffffff',
            fontFamily: theme.font_family,
          }}
        />
        <Chip
          label="Secondary"
          sx={{
            backgroundColor: theme.secondary_color,
            color: '#ffffff',
            fontFamily: theme.font_family,
          }}
        />
        <Chip
          label="Accent"
          sx={{
            backgroundColor: theme.accent_color,
            color: '#ffffff',
            fontFamily: theme.font_family,
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Tooltip title="Notifications">
          <IconButton sx={{ color: theme.primary_color }}>
            <Badge
              badgeContent={4}
              sx={{
                '& .MuiBadge-badge': {
                  backgroundColor: theme.error_color || '#f44336',
                },
              }}
            >
              <NotificationsIcon />
            </Badge>
          </IconButton>
        </Tooltip>
        <Tooltip title="Edit">
          <IconButton sx={{ color: theme.secondary_color }}>
            <EditIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton sx={{ color: theme.error_color || '#f44336' }}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </Box>
    </Grid>
  );
};

ChipsBadgesShowcase.propTypes = {
  theme: PropTypes.object.isRequired,
};

export default ChipsBadgesShowcase;
